<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.title-box {
  display: flex;
  align-items: center;
  padding-left: 50px;
}

.title-box-name {
  width: 110px;
  flex-shrink: 0;
  text-align: right;
}

.title-box-name span {
  color: red;
}

.content-pagination-box.el-pagination {
  left: 0px;
}

.cleanDialog span{
  color:#4FA1A4
}

.cleanDialog-btn-box {
  padding-top: 40px;
  text-align: center;
  /* border-top: 1px solid #E5E5E5; */
  border-radius: 0 0 6px 6px;
  bottom: 0px;
  z-index: 9;
  background-color: #ffffff;
  left: 130px;
  width: 100%;
}
.search-area-div{
  flex-shrink: 0;
  margin-right: 4px;
  text-align:right
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div required">所属公司</div>
          <el-select v-model="search.tenantGuid" placeholder="请选择" filterable class="ipt-sty" @change="companyChange">
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div required">客户类型</div>
          <el-select v-model="search.customerType" placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in customerTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" v-show="search.customerType === '1'">
          <div class="search-area-div">医院名称</div>
          <el-input v-model="search.medName" class="ipt-sty" clearable placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6" v-show="search.customerType === '2' || search.customerType === ''">
          <div class="search-area-div">客户名称</div>
          <el-input v-model="search.customerName" class="ipt-sty" clearable placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6" v-show="search.customerType === '3'">
          <div class="search-area-div">商业公司名称</div>
          <el-input v-model="search.franchiseeName" class="ipt-sty" clearable placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">清洗结果</div>
          <el-select v-model="search.cleaningResult" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in cleaningResultList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">所属省份</div>
          <el-select v-model="search.province" placeholder="请选择" class="ipt-sty" clearable filterable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否清洗</div>
          <el-select v-model="search.isCleanout" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in isMissingList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">地址是否缺失</div>
          <el-select v-model="search.isAddressMissing" placeholder="请选择" class="ipt-sty " clearable collapse-tags>
            <el-option v-for="item in isMissingList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <!-- <el-col :span="6">
          <div class="search-area-div">导入时间</div>
          <el-date-picker size="mini" class="ipt-sty" v-model="timeRange" type="daterange" align="left" unlink-panels
            range-separator="-" start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col> -->
        <el-col :span="6">
          <div class="search-area-div">清洗时间</div>
          <el-date-picker size="mini" class="ipt-sty" v-model="cleanTimeRange" type="daterange" align="left" unlink-panels
            range-separator="-" start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">创建时间</div>
          <el-date-picker size="mini" class="ipt-sty" v-model="createTimeRange" type="daterange" align="left" unlink-panels
            range-separator="-" start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
      </el-row>
    </div>
    <div class=" back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area p10">
        <!-- TODO暂时注释 医院导入上线后再加上 -->
        <!-- <el-button size="mini" type="info" @click="batchImport">导入数据</el-button> -->
        <el-button size="mini" type="info" @click="batchCleaning()">批量清洗地址</el-button>
        <el-button size="mini" type="info" @click="report" v-loading.fullscreen.lock="fullscreenLoading">批量导出</el-button>
      </div>
      <!-- 医院 -->
      <el-table v-if="search.customerType === '1'" :height="tableHeight" :data="tableData" border ref="multipleTable"
        v-loading="tableLoading" style="width: 100%" @selection-change="handleSelectionChange" stripe
        :row-key="(row) => row.guid" @row-click="handleClickTableRow">
        <el-table-column type="selection" :reserve-selection="true" width="60" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed>
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" width="240" label="所属公司" header-align="center" align="left"
          show-overflow-tooltip fixed>
          <template slot-scope="scope">
            {{ scope.row.tenantName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="medName" width="240" label="医疗机构标准名称" header-align="center" align="left"
          show-overflow-tooltip fixed>
          <template slot-scope="scope">
            {{ scope.row.medName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="terminalProperty" width="110" label="机构类别" header-align="center" align="left">
          <template slot-scope="scope">
            {{ getOrgTypeName(scope.row.orgType) }}
          </template>
        </el-table-column>
        <el-table-column prop="medStandardName" min-width="240" label="其他名称" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.medStandardName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="orgRank" width="96" label="机构级次" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getOrgRankName(scope.row.orgRank) }}
          </template>
        </el-table-column>
        <el-table-column prop="orgGrade" width="96" label="机构等级" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.orgGrade | orgGrade }}
          </template>
        </el-table-column>
        <el-table-column prop="venue" width="110" label="省" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.province | province }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="110" label="市" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.city | city }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="120" label="区/县" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.district | district }}</template>
        </el-table-column>
        <el-table-column prop="address" label="详细地址" min-width="240" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.address || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="region" label="经度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.lng || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="纬度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.lat || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="是否清洗" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.isCleanout | getVisible }}</template>
        </el-table-column>
        <el-table-column prop="region" label="清洗结果" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.cleaningResult | cleaningResult }}</template>
        </el-table-column>
        <el-table-column prop="region" label="清洗时间" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.cleaningTime | getTimeDate }}</template>
        </el-table-column>
        <!-- <el-table-column prop="region" label="匹配结果" header-align="center" width="130" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.matchingResult | matchingResult }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图省份" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapProvince || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图市" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapCity || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图区/县" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapDistrict || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图地址" header-align="center" min-width="240" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapAddress || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图经度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapLng || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图纬度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapLat || '-' }}</template>
        </el-table-column> -->
        <el-table-column prop="contacts" width="96" label="医院联系人" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contacts || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="contactTel" width="120" label="手机号码" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contactTel || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="120" label="所属人员姓名" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createUserName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="mobileNo" width="120" label="所属人员手机号" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.mobileNo || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="medCode" width="120" label="医疗机构编码" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.medCode || '-' }}
          </template>
        </el-table-column>     
          <el-table-column prop="createTime" label="创建时间" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="mapSelection(scope.row)">地图选点
            </a>
          </template>
        </el-table-column>
      </el-table>
      <!-- 药店 -->
      <el-table v-if="search.customerType === '2'||search.customerType === ''" :height="tableHeight" :data="tableData" border ref="multipleTable"
        v-loading="tableLoading" style="width: 100%" @selection-change="handleSelectionChange" stripe
        :row-key="(row) => row.guid" @row-click="handleClickTableRow">
        <el-table-column type="selection" :reserve-selection="true" width="60" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed>
          <template slot-scope="scope">

            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" width="240" label="所属公司" header-align="center" align="left"
          show-overflow-tooltip fixed>
          <template slot-scope="scope">
            {{ scope.row.tenantName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="customerName" width="240" label="药店名称" header-align="center" align="left"
          show-overflow-tooltip fixed>
          <template slot-scope="scope">
            {{ scope.row.customerName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="terminalProperty" width="140" label="药店属性" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">
            {{ scope.row.terminalProperty || '-' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="region" label="大区" show-overflow-tooltip header-align="center" width="150" align="center">
          <template slot-scope="scope">{{ scope.row.region}}</template>
        </el-table-column>   -->
        <el-table-column prop="venue" width="110" label="省" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.province | province }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="110" label="市" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.city | city }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="130" label="区/县" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.district | district }}</template>
        </el-table-column>
        <el-table-column prop="address" label="详细地址" min-width="240" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">
            {{ scope.row.address || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="region" label="经度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.lng || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="纬度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.lat || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="是否清洗" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.isCleanout | getVisible }}</template>
        </el-table-column>
        <el-table-column prop="region" label="清洗结果" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.cleaningResult | cleaningResult }}</template>
        </el-table-column>
        <el-table-column prop="region" label="清洗时间" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.cleaningTime | getTimeDate }}</template>
        </el-table-column>
        <!-- <el-table-column prop="region" label="匹配结果" header-align="center" width="130" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.matchingResult | matchingResult }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图省份" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapProvince || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图市" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapCity || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图区/县" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapDistrict || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图地址" header-align="center" min-width="240" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapAddress || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图经度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapLng || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图纬度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapLat || '-' }}</template>
        </el-table-column> -->
        <el-table-column prop="contacts" width="110" label="药店联系人" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">
            {{ scope.row.contacts || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="contactTel" width="120" label="药店联系电话" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">
            {{ scope.row.contactTel || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="120" label="业务指派人员" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">
            {{ scope.row.createUserName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="mobileNo" width="120" label="指派人手机号" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">
            {{ scope.row.mobileNo || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="customerCode" width="140" label="药店编码" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">
            {{ scope.row.customerCode || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="mapSelection(scope.row)">地图选点
            </a>
          </template>
        </el-table-column>
      </el-table>
      <!-- 商业公司 -->
      <el-table v-if="search.customerType === '3'" :height="tableHeight" :data="tableData" border ref="multipleTable"
        v-loading="tableLoading" style="width: 100%" @selection-change="handleSelectionChange" stripe
        :row-key="(row) => row.guid" @row-click="handleClickTableRow">
        <el-table-column type="selection" :reserve-selection="true" width="60" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed>
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" width="240" label="所属公司" header-align="center" align="left"
          show-overflow-tooltip fixed>
          <template slot-scope="scope">
            {{ scope.row.tenantName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="franchiseeName" width="240" label="商业公司名称" header-align="center" align="left"
          show-overflow-tooltip fixed>
          <template slot-scope="scope">
            {{ scope.row.franchiseeName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="region" label="大区" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.region | region }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="110" label="省" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.province | province }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="110" label="市" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.city | city }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="150" label="区/县" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.district | district }}</template>
        </el-table-column>
        <el-table-column prop="address" label="详细地址" min-width="240" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.address || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="region" label="经度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.lng || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="纬度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.lat || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="是否清洗" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.isCleanout | getVisible }}</template>
        </el-table-column>
        <el-table-column prop="region" label="清洗结果" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.cleaningResult | cleaningResult }}</template>
        </el-table-column>
        <el-table-column prop="region" label="清洗时间" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.cleaningTime | getTimeDate }}</template>
        </el-table-column>
        <!-- <el-table-column prop="region" label="匹配结果" header-align="center" width="130" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.matchingResult | matchingResult }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图省份" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapProvince || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图市" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapCity || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图区/县" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapDistrict || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图地址" header-align="center" min-width="240" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapAddress || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图经度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapLng || '-' }}</template>
        </el-table-column>
        <el-table-column prop="region" label="地图纬度" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mapLat || '-' }}</template>
        </el-table-column> -->
        <el-table-column prop="contacts" width="96" label="联系人" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contacts || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="contactTel" width="110" label="联系电话" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contactTel || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="120" label="所属人员姓名" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createUserName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="mobileNo" width="120" label="所属人员手机号" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.mobileNo || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="property" width="120" label="商业公司类型" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.property || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="franchiseeCode" width="120" label="商业公司编码" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.franchiseeCode || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="mapSelection(scope.row)">地图选点
            </a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="page.customerType" class="pt pb back-color-fff content-pagination-box" background
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]"
        :current-page="page.pageIndex" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows">
      </el-pagination>
    </div>
    <el-dialog title="地图选点" :visible.sync="dialogVisible" width="1300px">
      <dialogMap v-if="dialogVisible" ref="refMap" :markers="markers" @getMarkers="getMarkers" @close="close">
      </dialogMap>
    </el-dialog>
    <el-dialog title="地址清洗" :visible.sync="cleanDialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" width="420px"  :center="false" custom-class="cloudBody">
      <div class="cleanDialog">
        <img v-if="!cleanFlag" src="@/assets/images/clean.png" alt="" style="width:168px;height:96px">
        <img v-else src="@/assets/images/cleanSuccess.png" alt="" style="width:168px;height:96px">
        <p v-if="!cleanFlag">终端地址清洗中，预计清洗 <span>{{ cleanLength }}</span> 条，已清洗 <span>{{ currentCleanNumber }}</span>  条</p>
        <p v-else>终端地址清洗完成，预计清洗 <span>{{ cleanLength }}</span> 条，已清洗<span> {{ currentCleanNumber }}</span> 条</p>
      </div>
      <div class="cleanDialog-btn-box">
        <el-button type="default" size="small" v-if="!cleanFlag" @click="cancelCleaning()">取消</el-button>
        <el-button type="default" size="small" v-else @click="cleanDialogVisible = false">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import btnPermisson from '../mixins/btnPermisson';
import areaJson from '../../assets/js/china_address_v4.js';
import dialogMap from '../../components/dialogMap';
import recentDate from "@/uilt/recentDate";
export default {
  components: {
    dialogMap,
  },
  mixins: [btnPermisson],
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 274,
      contentMainHeight: window.innerHeight - 200,
      dialogVisible: false,
      cleanDialogVisible: false,
      maintainState: 1,
      currentCleanNumber: 0,
      currentItem: {},
      progressGuid: '',
      cleanLength: 0,
      timer: '',
      cleanTimeRange:'',
      createTimeRange:'',
      cleanFlag: false,
      orgRankList: [],
      options: areaJson,
      timeRange: [],
      markers: {},
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
      },
      search: {
        staffName: '',
        startTime: '',
        customerType: '',
        isAddressMissing: 'Y',
        cleaningResult: '',
        matchingDifference: '',
        endTime: '',
        medName: '',
        franchiseeName: '',
        tenantGuid: '',
        // 是否清洗
        isCleanout: '',
        maintainState: '',
        property: [],
      },
      tenantList: [],
      tableData: [],
      sendTime: '',
      right: 'right',
      fullscreenLoading: false,
      tableLoading: false,
      cleaningResultList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '匹配成功'
        },
        {
          value: '2',
          label: '匹配失败'
        },
        {
          value: '3',
          label: '修订'
        }
      ],
      isMissingList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'Y',
          label: '是'
        },
        {
          value: 'N',
          label: '否'
        }
      ],
      customerTypeOptions: [
        {
          value: '1',
          label: '医院'
        },
        {
          value: '2',
          label: '药店'
        },
        {
          value: '3',
          label: '商业公司'
        }
      ],
      isDifferenceList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'Y',
          label: '存在'
        },
        {
          value: 'N',
          label: '不存在'
        }
      ],
      multipleSelectionGuid: [],
      multipleSelection: [],
      num: '',
      //新增分配
      dialogCustomer: false,
      tenantName: '',
      organisationNames: '',
      staffList: [],
      staffForm: {
        guids: [],
        staffGuid: '',
        userGuid: '',
        staffName: ''
      },
    };
  },
  // beforeRouteLeave(to, from, next) {
  //   if (to.name == 'importHospital' || to.name == 'importNewManagementList') {
  //     next()
  //     return
  //   }
  //   this.$confirm('确定离开该页面吗?请确保已提交了清洗的内容', '提示', {
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     type: 'warning'
  //   }).then(() => {
  //     next()
  //   }).catch(() => {
  //     console.log(window, this, localStorage);
  //     next(false)
  //   });
  // },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 330;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 280;
        return;
      }
    },
    search: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.$refs.multipleTable?.clearSelection()
        })
      },
      deep: true
    },
    "search.customerType": {
      handler(val, oldVal) {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout();
        });
        if (!this.search.tenantGuid) {
          this.$message.error('请选择所属公司')
          return
        }
        switch (val) {
          case '1':
            this.search.franchiseeName = ''
            this.search.customerName = ''

            break;
          case '2':
            this.search.franchiseeName = ''
            this.search.medName = ''
            break;
          case '3':
            this.search.customerName = ''
            this.search.medName = ''
            break;
          default:
            break;
        }
        this.tableData = [],
          this.$nextTick(() => {
            this.$refs.multipleTable.clearSelection()
          })
        this.getData(true)
      }
    },
    "search.tenantGuid": {
      handler(val, oldVal) {
        if (this.search.customerType == "") {
          return
        }
        this.tableData = [],
          this.getData(true)
      }
    }
  },
  activated() {
    this.getData(true);
  },
  async created() {
    await this.getFormMedConfig()
    this.getTenantOperationRelList(true);
    //按钮权限
    this.getMenuList();
    this.getLevelList(2)
    // this.$refs.multipleTable.doLayout()
  },
  methods: {
    mapSelection(item) {
      this.currentItem = item;
      this.markers.lat = this.currentItem.mapLat;
      this.markers.lng = this.currentItem.mapLng;
      this.dialogVisible = true;
    },
    getMarkers(marker) {
      console.log('markermarker', marker);
      this.dialogVisible = false;
      this.currentItem.province = marker.province;
      this.currentItem.city = marker.city;
      this.currentItem.district = marker.district;
      this.currentItem.address = marker.address;
      this.currentItem.lng = marker.lng;
      this.currentItem.lat = marker.lat;
      let { guid, province, city, district, address, lng, lat } = this.currentItem
      this.api.postJson(`/${serverConfig.msCustomerService}/terminal/get-mapLocation`, { guid, province, city, district, address, lng, lat, customerType: this.search.customerType }).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success("操作成功");
          this.getData()
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    close() {
      this.dialogVisible = false;
    },
    submitForm() {
      this.$confirm('确定提交本次清洗的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    cancel() {
      this.$confirm('确定取消本次清洗吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    },
    getImportProgress() {
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msCommonAdminCloudService}/excel/import/get-import-progress?guid=` + self.progressGuid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data == null) {
              self.currentCleanNumber = 0;
            } else {
              self.currentCleanNumber = res.data.data;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 批量清洗
    batchCleaning() {
      console.log(this.$refs.multipleTable.selection);
      if (this.$refs.multipleTable.selection.length > 1000) {
        this.$message.error('每次最多可清洗1000条')
        return
      }
      if (this.$refs.multipleTable.selection.length === 0) {
        this.$message.error('请先勾选数据')
        return
      }
      this.cleanLength = this.$refs.multipleTable.selection.length
      this.currentCleanNumber = 0
      this.progressGuid = this.generateUUID()
      let data = this.$refs.multipleTable.selection.map(item => {
        item.customerType = this.search.customerType,
          item.province = this.$options.filters.province(item.province),
          item.city = this.$options.filters.city(item.city),
          item.district = this.$options.filters.district(item.district)
        return item
      })
      this.cleanDialogVisible = true
      this.cleanFlag = false
      this.timer = setInterval(this.getImportProgress, 1000);
      this.api.postJson(`/${serverConfig.msCustomerService}/terminal/address-batchcleaning?progressGuid=${this.progressGuid}`, data).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          clearInterval(this.timer);
          this.currentCleanNumber = res.data.data
          this.cleanFlag = true
          this.getData(true)
          this.$nextTick(() => {
            this.$refs.multipleTable.clearSelection()
          })
          console.log(res.data);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 取消清洗
    cancelCleaning() {
      this.api
        .postJson(
          `/${serverConfig.msCustomerService}/terminal/address-stop-batchcleaning`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            clearInterval(this.timer);
            this.cleanDialogVisible=false
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    cancelClean() { },
    //点击行选中
    handleClickTableRow(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //批量分配
    batchCustomer() {
      if (!this.search.tenantGuid) {
        this.$message.error('请先选择所属企业！')
        return
      }
      if (!this.tableData.length) {
        this.$message.error('暂无数据！')
        return
      }
      if (!this.multipleSelection.length) {
        this.$message.error('请勾选数据！');
        return
      }
      this.dialogCustomer = true;
    },
    companyChange(val) {
      this.getStaff()
      this.tenantList.forEach(i => {
        if (i.sendTenantGuid == val) {
          this.tenantName = i.sendTenantName;
        }
      })
    },
    changeStaff(val) {
      if (this.staffList && this.staffList.length > 0) {
        this.staffList.forEach(i => {
          if (val == i.guid) {
            this.staffForm.userGuid = i.userGuid;
            this.staffForm.staffName = i.staffName;
            this.organisationNames = i.organisationNames;
          }
        })
      }
    },
    //获取人员下拉
    getStaff() {
      this.api.get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=${this.search.tenantGuid}`
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffList = res.data.data;
        }
      });
    },
    getTenantOperationRelList(flg) {
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` + '&tenantGuid=' + localStorage.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    empty() {
      let self = this;
      this.timeRange = [],
      this.cleanTimeRange=[],
      this.createTimeRange=[],
        this.page = {
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
        }
      this.search = {
        staffName: '',
        startTime: '',
        customerType: this.search.customerType,
        endTime: '',
        medName: '',
        isCleanout: '',
        cleaningResult: '',
        isAddressMissing: '',
        franchiseeName: '',
        matchingDifference: '',
        tenantGuid: this.search.tenantGuid,
        filingMethod: '',
        maintainState: '',
        property: [],
      },
        self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if (!this.search.tenantGuid ){
        this.$message.error("请选择所属公司")
        return
      }
      if (!this.search.customerType ){
        this.$message.error("请选择客户类型")
        return
      }
      // if (!self.timeRange) {
      //   self.search.startTime = ""
      //   self.search.endTime = ""
      // } else if (self.timeRange && self.timeRange.length != 0) {
      //   self.search.startTime = self.timeRange[0] + ' ' + '00:00:00';
      //   self.search.endTime = self.timeRange[1] + ' ' + '23:59:59';
      // }
      if (!self.cleanTimeRange) {
        self.search.startCleaningTime = ""
        self.search.endCleaningTime = ""
      } else if (self.cleanTimeRange && self.cleanTimeRange.length != 0) {
        self.search.startCleaningTime = self.cleanTimeRange[0] + ' ' + '00:00:00';
        self.search.endCleaningTime = self.cleanTimeRange[1] + ' ' + '23:59:59';
      }
      if (!self.createTimeRange) {
        self.search.startTime = ""
        self.search.endTime = ""
      } else if (self.createTimeRange && self.createTimeRange.length != 0) {
        self.search.startTime = self.createTimeRange[0] + ' ' + '00:00:00';
        self.search.endTime = self.createTimeRange[1] + ' ' + '23:59:59';
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/terminal/get-address-cleaningList?isDeficiency=${self.search.isAddressMissing}`, Object.assign(self.page, self.search)).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          console.log('page',self.page);
          
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 机构类别字典
    getFormMedConfig() {
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        functionCode: 'YYJD',
        tenantGuid: localStorage.guid,
        organisationGuid: userInfo.organisationGuid
      }
      this.api.postJson(
        `/${serverConfig.msConfigureService}/function/function-tenant-field/get-config`,
        query
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          localStorage.setItem('YYJD_CONFIG', JSON.stringify(data.fieldList))
          // this.isInitConfig = true;
          // this.initPage();
          // console.log(this.data)

        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getOrgTypeName(value) {
      // let orgTypeList = this.orgTypeList;
      let orgTypeList = this.transform(this.getFieldConfig('orgType', 'selectItemList'));

      let item = orgTypeList.filter(item => item.value == value)
      // return item.length && item[0].label || '-';
      return item.length && item[0].name || '-';
    },
    getOrgRankName(value) {
      // console.log(this.orgRankList)
      let orgRankList = this.orgRankList;
      let item = orgRankList.filter(item => item.value == value)
      return item.length && item[0].text || '-';
    },
    getFieldConfig(params, key) {
      var fieldList = JSON.parse(localStorage.getItem("YYJD_CONFIG"));
      var newConfig = {};
      if (!fieldList) return
      fieldList.forEach((item) => {
        if (item.fieldName == params) {
          newConfig = item;
        }
      });
      return (newConfig && newConfig[key]) || undefined;
    },
    transform(list) {
      if (!list) return;
      var newList = [];
      list.forEach((item) => {
        newList.push({
          name: item.text,
          value: item.value,
        });
      });
      return newList;
    },
    addPath() {
      this.$router.push({
        path: '/commercialCompanyinquiryDetail/detail',
        query: { tenantGuid: this.search.tenantGuid, productGuid: this.$route.query.productGuid }
      });
    },
    editPath(guid, disabled) {
      this.$router.push({
        path: '/commercialCompanyinquiryDetail/detail',
        query: { disabled, guid: guid, tenantGuid: this.search.tenantGuid, productGuid: this.$route.query.productGuid }
      });
    },
    lookPath(row) {
      this.$router.push({
        path: '/businessCustomerList',
        query: { tenantGuid: this.search.tenantGuid, franchiseeName: row.franchiseeName, productGuid: this.$route.query.productGuid }
      });
    },
    getLevelList(type) {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=${type == 1 ? '城市等级' : type == 2 ? '医院级别' : '会议类型'}`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            data.forEach(item => {
              item.value = item.value;
            })
            type == 1 ? this.cityLevelList = data : type == 2 ? this.orgRankList = data : this.meetingTypeList = data
          }
        });
    },
    batchImport() {
      if (!this.search.customerType) {
        this.$message.error('请选择客户类型')
      }
      switch (this.search.customerType) {
        case '1':
          this.$router.push({ path: '/importHospital', query: { productGuid: this.$route.query.productGuid,type:'0008' } });
          break;
        case '2':
          this.$router.push({ path: '/importNewManagementList', query: { productGuid: this.$route.query.productGuid ,type:'0010'} });
          break;
        case '3':
          this.$router.push({ path: '/importNewManagementList', query: { productGuid: this.$route.query.productGuid ,type:'0009'} });
          break;
      }
    },
    report() {
      let self = this;
      self.fullscreenLoading = true;
      // self.page.pageSize = -1;
      // self.page.performanceGuid = self.$router.history.current.query.guid;
      self.api.postJson(`/${serverConfig.msCustomerService}/terminal/batchcleaning-report?isDeficiency=${self.search.isAddressMissing}`, Object.assign(self.page, self.search)).then(res => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.fullscreenLoading = true;
      self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, { 'colNames': colNames, 'datas': datas, 'sheetName': sheetName, 'fileNam': fileNam })
        .then(res => {
          let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a')
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
      // self.empty();
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
        self.staffForm.guids.push(item.guid)
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #DCDFE6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

/deep/ .el-table__fixed {
  height: auto !important;
  bottom: 12px !important;
}
/deep/ .cloudBody{
  height:320px !important;
}
/deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
/deep/.el-dialog__header {
  text-align:left
}
/deep/ .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
  /* padding:0 0 20px 0 !important; */
  padding: 10px 20px;
}

/deep/ .el-button--primary:focus,
/deep/ .el-button--primary:hover {
  background: #4fa1a4 !important;
  border-color: #4fa1a4 !important;
}
.required::before {
  content: "*";
  color: red;
}
.el-col-6 {
  display: flex;
  word-break: keep-all;
}
</style>